import { css } from '@microsoft/fast-element';
import { scrollbarStyles } from '../../../styles';

export const NegotiationDetailModalStyles = css`
  ${scrollbarStyles}
`;
